(function () {
    'use strict';

    class SessionCardController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, moment, $element, Enums, AnalyticsService, SchedulingService, $timeout, $translate, TimezoneService, AppStates, $state, $filter) {
            super($scope, $injector);
            this.__objectType = 'SessionCardController';

            this.moment = moment;
            this.$element = $element;
            this.Enums = Enums;
            this.AnalyticsService = AnalyticsService;
            this.SchedulingService = SchedulingService;
            this.$timeout = $timeout;
            this.$translate = $translate;
            this.TimezoneService = TimezoneService;
            this.AppStates = AppStates;
            this.$state = $state;
            this.$filter = $filter;

            this.teamMembers = undefined;
            this.copyLinkTooltip = "Copy Link";
        }

        $onInit() {

            // set session type
            this._sessionType = this.getSessionTypeText(this.session);

            // build session duration text
            this._description = this.SchedulingService.getSessionDescriptionText(this.session);

            // set editable state
            this.editable = this.isEditable();
        }

        isEditable() {
            return this.user.hasCompanyAdminPermissions() ||
                this.user._id === this.session.user_id;
        }

        getSessionTypeText (session) {
            switch(session.session_type) {
                case this.Enums.sessionType.inPerson:
                    return 'SCHEDULING.SESSION.SESSION_TYPES._MEETING_';
                case this.Enums.sessionType.phoneCall:
                    return 'SCHEDULING.SESSION.SESSION_TYPES._PHONE_CALL_';
                case this.Enums.sessionType.videoCall:
                    return 'SCHEDULING.SESSION.SESSION_TYPES._VIDEO_CALL_';
                default:
                    return 'SCHEDULING.SESSION.SESSION_TYPES._OTHER_';
            }
        }

        onToggle() {
            this.onSessionUpdate({session: this.session});
        }

        editSession() {
            this.$state.go(this.AppStates.root_core_sessionConfig, { sessionId: this.session._id });
        }

        showSharedWith(event) {
            if(!this.teamMembers) {
                const companyMembers = this.company.getAllCompanyMembers();
                this.teamMembers = companyMembers.filter(member => this.session.shared_member_ids.includes(member._id))
            }
            this.shouldShowSharedWith = true;
            this.preventCardClick(event);
        }

        getSessionUrl() {
            return this.session.session_url;
        }

        linkCopied() {
            let elem = this.$element.find('.session-item__copy')[0];
            this.linksIsCopied = true;
            this.copyLinkTooltip = "Link copied!";

            this.$timeout(() => {
                elem._tippy.hide();
            }, 2000);

            this.$timeout(() => {
                this.linksIsCopied = false;
                this.copyLinkTooltip = "Copy link";
            }, 2500);
        }

        onCardClick() {
            if(this.editable) {
                this.editSession();
            }
        }

        preventCardClick(event) {
            event.stopPropagation();
        }

    }

    Components.SessionCard = {
        bindings: {
            session: '<',
            onSessionUpdate: '&',
            company: '<',
            user: '<'
        },
        transclude: true,
        controller: SessionCardController,
        controllerAs: 'sessionCardVm',
        name: 'hbSessionCard',
        templateUrl: 'angular/app/modules/core/features/calendar/scheduling/session_card/session_card.html',
    };

}());
